import { axiosGet } from '@/app/helpers/AxiosHelper';

export default {
  state: {
    id: null,
    app: null,
    evaluation: {}
  },

  mutations: {
    SET_APP(state, data) {
      state.app = data;
    },
  },

  actions: {
    getAccAppData({ commit, state }) {
      const url = `/accreditations/applications/form/${state.id}`;
      axiosGet(url).then(res => {
        if (res.status == 200) {
          commit('SET_APP', res.data);
        }
      });
    },
  }
}